module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_user-318295a56d4ba1c8f0b4716800985b3e.svg";